import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  Inject,
  Input,
  OnDestroy,
  ViewChild
} from "@angular/core";
import { DOCUMENT } from "@angular/common";
import { BehaviorSubject, Subject } from "rxjs";
import { filter, switchMap, takeUntil } from "rxjs/operators";
import { ExtendedMediaStream, mapStreamToCanvas } from "youm-lib";

@Component({
  selector: "app-canvased-video",
  templateUrl: "./canvased-video.component.html",
  styleUrls: ["canvased-video.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CanvasedVideoComponent implements AfterViewInit, OnDestroy {
  @ViewChild("canvasRef") _canvasRef!: ElementRef<HTMLCanvasElement>;

  @Input() set stream(value: null | ExtendedMediaStream) {
    this._stream$.next(value);
  }

  private readonly _stream$ = new BehaviorSubject<null | ExtendedMediaStream>(
    null
  );
  private readonly _destroy$ = new Subject<void>();

  constructor(@Inject(DOCUMENT) private readonly _document: Document) {}

  ngAfterViewInit() {
    const canvas = this._canvasRef.nativeElement;

    this._stream$
      .pipe(
        filter((_): _ is ExtendedMediaStream => !!_),
        switchMap((_) =>
          mapStreamToCanvas(_, canvas, () =>
            this._document.createElement("video")
          )
        ),
        takeUntil(this._destroy$)
      )
      .subscribe((_) => _);
  }

  ngOnDestroy() {
    this._destroy$.next();
    this._destroy$.complete();
  }
}
